import { Button } from "@/components/ui/button";

export default function Pager({ page, pages, total, onPage, testid = "pager" }) {
  return (
    <div className="flex items-center justify-between gap-2 pt-3 text-xs text-slate-500" data-testid={testid}>
      <span data-testid={`${testid}-total`}>{total} result{total === 1 ? "" : "s"} · page {page} of {pages}</span>
      <div className="flex gap-1">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`}>Previous</Button>
        <Button size="sm" variant="outline" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`}>Next</Button>
      </div>
    </div>
  );
}
